module.exports = __webpack_public_path__ + "static/img/14000310.6fb31839.png";